// src/pages/PatternsPrints/index.jsx
import React, { useEffect, useState } from "react";
import CollectionPage from "../CollectionPage";
import { getPatternsPrints, PRODUCTS_PER_PAGE } from "../../data/Patternsprints";

export default function PatternsPrints() {
  const [products, setProducts] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    getPatternsPrints()
      .then(setProducts)
      .catch(err => setError(err.message || "Failed to load products"));
  }, []);

  if (error) {
    return <div className="min-h-screen flex items-center justify-center text-red-600">{error}</div>;
  }
  if (!products) {
    return <div className="min-h-screen flex items-center justify-center text-gray-500">Loading...</div>;
  }

  const config = {
    products,
    productsPerPage: PRODUCTS_PER_PAGE,
    basePath: "/patterns-prints",
    announcement: {
      headline: "Patterns & Prints — notebooks as bold as your ideas!",
      subtext: "300+ designs to personalise • No code required",
    },
    hero: {
      title: "Patterns & Prints",
      subtitle: "Bold prints, beautifully bound",
     featuredIn: ["PREMIUM QUALITY", "TRUSTED CRAFTSMANSHIP", "PAN INDIA DELIVERY"],
      quote: "I've never seen a notebook this beautiful — the print quality is stunning and the paper is perfect.",
      quoteLink: "#",
      rating: "4.8",
      ratingCount: "1000+",
    },
  };

  return <CollectionPage config={config} />;
}